import React from "react";
import { MdFilterList, MdOutlineClear } from "react-icons/md";
import EAButton from "../../../shared/Buttons/EAButton";
import EAIconButton from "../../../shared/Buttons/EAIconButton";
import EAScheduleDatePicker from "../../../shared/EAScheduleDatePicker/EAScheduleDatePicker";
import CourtFiltersModal from "./CourtFiltersModal";
import useCourtBar from "./useCourtBar";
import useAttractionsCalendar from "../../hooks/useAttractionsCalendar";
import useFacility from "../../../../../utils/hooks/useFacility";
import { CourtGridCourt } from "../../../../models/CourtGridData";
import "./style.scss";

interface IProps {
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
  availableCourts: CourtGridCourt[];
  selectedCourts: string[];
  setSelectedCourts: (courts: string[]) => void;
  updateCourtFilters?: (selectedCourts: string[], availableCourts: string[]) => void;
  persistentSelectedCourts?: string[];
  exerciseName?: string;
}

const CourtBar: React.FC<IProps> = ({
  selectedDate,
  setSelectedDate,
  availableCourts,
  selectedCourts,
  setSelectedCourts,
  updateCourtFilters,
  persistentSelectedCourts,
  exerciseName,
}) => {
  const facilityIds = useFacility();
  const { unavailableDates } = useAttractionsCalendar(facilityIds);
  const {
    openFilters,
    setOpenFilters,
    isMobile,
    hasFiltersSelected,
    handleClearFilters,
  } = useCourtBar({
    selectedDate,
    setSelectedDate,
    availableCourts,
    selectedCourts,
    setSelectedCourts,
  });

  const handleClearAllFilters = () => {
    if (updateCourtFilters) {
      // Przekaż pustą tablicę jako selectedCourts i dostępne korty jako availableCourts
      // To spowoduje wyczyszczenie zarówno bieżących jak i persystentnych filtrów
      updateCourtFilters(
        [],
        availableCourts.map((court) => court.courtName),
      );
    } else {
      handleClearFilters();
    }
  };

  return (
    <>
      <div className="court-bar">
        <div className="court-bar__section">
          {isMobile ? (
            <>
              <EAIconButton
                title="Filtry"
                icon={<MdFilterList />}
                variant="icon"
                onClick={() => setOpenFilters(true)}
              />
              {hasFiltersSelected && (
                <EAIconButton
                  title="Wyczyść filtry"
                  icon={<MdOutlineClear />}
                  variant="icon"
                  onClick={handleClearAllFilters}
                />
              )}
            </>
          ) : (
            <>
              <EAButton
                title={hasFiltersSelected ? "Wybrano filtry" : "Filtry"}
                onClick={() => setOpenFilters(true)}
                variant="outlined"
              />
              {hasFiltersSelected && (
                <EAButton
                  title="Wyczyść filtry"
                  onClick={handleClearAllFilters}
                  startIcon={<MdOutlineClear />}
                  variant="text"
                />
              )}
            </>
          )}
        </div>

        <div className="court-bar__section">
          <EAScheduleDatePicker
            selectedDate={selectedDate}
            onDateChange={setSelectedDate}
            requireConfirmation={true}
            unavailableDays={unavailableDates}
          />
        </div>
      </div>

      {openFilters && (
        <CourtFiltersModal
          open={openFilters}
          setOpen={setOpenFilters}
          availableCourts={availableCourts}
          selectedCourts={selectedCourts}
          setSelectedCourts={setSelectedCourts}
          updateCourtFilters={updateCourtFilters}
          persistentSelectedCourts={persistentSelectedCourts}
          exerciseName={exerciseName}
        />
      )}
    </>
  );
};

export default CourtBar;
